import { useState, useEffect } from 'react';
import { useReactFlow, useNodeId } from '@xyflow/react';

const TextContent = ({ data }: { data: any }) => {
  const { updateNodeData } = useReactFlow();
  const nodeId = useNodeId();
  const [text, setText] = useState(data.text || '');

  // Debounce update to avoid too many re-renders/history updates
  useEffect(() => {
    const timer = setTimeout(() => {
      if (nodeId) updateNodeData(nodeId, { text });
    }, 300);
    return () => clearTimeout(timer);
  }, [text, nodeId, updateNodeData]);

  return (
    <div className="flex flex-col gap-2 p-1">
      <label className="text-xs text-slate-400">Content</label>
      <textarea
        className="w-full h-24 bg-slate-900 border border-slate-700 rounded p-2 text-xs text-slate-200 resize-none focus:outline-none focus:border-blue-500 nodrag"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Enter your prompt..."
        onKeyDown={(e) => e.stopPropagation()} // Prevent triggering canvas shortcuts
      />
    </div>
  );
};

export default TextContent;